// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmbedComponent_wrapper__1bfCi","selected":"EmbedComponent_selected__3WIha","tools":"EmbedComponent_tools__iqKZX","input":"EmbedComponent_input__1bUOj"};